<template>
  <div id="dashboard-page">
    <b-card class="mb-5">
      <b-row>
        <b-col md="10">
          <h3>Reimbursement</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">{{ $t('dashboard') }}</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/new-reimbursement">{{
                $t('reimbursement')
              }}</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <b-col md="2 mt-3">
          <b-button
            v-b-tooltip.hover.top
            :title="$t('exportExcel')"
            @click="doExportToExcel"
            variant="info"
            class="mb-2 btn-download float-right"
            ><font-awesome-icon icon="download"
          /></b-button>
        </b-col>
      </b-row>
      <div class="border-bottom mb-2"></div>
      <b-row>
        <b-col md="8" class="mb-3">
          <div class="d-flex">
            <span class="my-3 dashboard-border"
              ><router-link to="/new-reimbursement/general">{{
                $t('reqReimburst')
              }}</router-link></span
            >
            <span class="ml-4 my-3 dashboard-border active"
              ><router-link style="color:#0056b3!important;" to="/reimbursement/payment">{{
                $route.name
              }}</router-link></span
            >
            <span class="ml-4 my-3 dashboard-border"
              ><router-link to="/new-reimbursement/history-reimbursement">{{
                $t('paidReimburst')
              }}</router-link></span
            >
            <span class="ml-4 my-3 dashboard-border"
              ><router-link to="/new-reimbursement/category-reimbursement">{{
                $t('reimburstCategory')
              }}</router-link></span
            >
          </div>
        </b-col>
      </b-row>
      <div class="border-bottom mb-2"></div>
      <b-form v-on:submit.prevent="getPaymentReimbursement()">
        <b-row>
          <b-col md="12">
            <b-row class="mt-2 mb-2">
              <b-col md="3 mb-2">
                <!-- <b-form-input v-on:keyup.enter="getPaymentReimbursement()" placeholder="Employee" v-model="tableFilter.search_employee" /> -->
              </b-col>
              <b-col md="3 mb-2">
                <!-- <date-picker
                  v-model="tableFilter.date"
                  type="date"
                  range
                  placeholder="Date Range"
                ></date-picker> -->
              </b-col>
              <b-col md="3 mb-2">
                <!-- <b-form-select v-model="tableFilter.statusreimbursement" :options="statusList" /> -->
              </b-col>
              <b-col md="3">
                <!-- <button type="submit" class="mb-2 ml-2 btn btn-primary float-right" id="btn-search">
                  <font-awesome-icon icon="search" /> Filter
                </button> -->
                <!-- <button
                  @click="clearFilter()"
                  class="ml-0 btn btn-outline-primary float-right"
                  id="btn-search"
                >
                  <font-awesome-icon icon="times-circle" /> Clear Filter
                </button> -->
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-form>
      <table class="table table-hovered table-striped">
        <thead>
          <tr>
            <th>{{ $t('date') }}</th>
            <th>{{ $t('employee') }}</th>
            <th>{{ $t('totalPay') }}</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <template v-if="isLoading">
          <tbody>
            <tr>
              <td colspan="10" class="text-center">
                <div class="text-center" style="margin: 3% auto;">
                  <b-spinner small type="grow" label="Small Spinner"></b-spinner>
                  <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
                  <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
        <template v-else>
          <tbody v-if="approvedReimburse.length > 0">
            <tr v-for="(payment, index) in approvedReimburse" :key="index">
              <td>
                <a
                  style="cursor: pointer"
                  class="font-weight-bold text-primary"
                  @click="showModalDetail(payment)"
                >
                  {{ getDateTime(payment.datetime) }}
                </a>
              </td>
              <td>{{ payment.name }}</td>
              <td>{{ dataAccount.account.currency }} {{ formatPrice(payment.amount) }}</td>
              <td>
                <div :id="'btn-popover-payment-' + index">
                  <b-badge :variant="getStatusColor(payment.status)">{{ getStatusName(payment.status) }}</b-badge>
                </div>
                <!-- <b-popover
                  v-if="payment.status === 'Approved'"
                  :target="'btn-popover-payment-' + index"
                  triggers="hover"
                  placement="left"
                >
                  <template v-slot:title>Pay</template>
                  <b-button
                    variant="primary"
                    size="sm"
                    class="btn-pay-popover"
                    @click="showModalPay('', payment)"
                    ><font-awesome-icon icon="donate"></font-awesome-icon> Pay</b-button
                  >
                </b-popover> -->
              </td>
              <td>
                <!-- <a
                  v-if="tableFilter.date !== null"
                  v-b-tooltip.hover.left
                  title="Details"
                  class="btn-op icon-info mr-1"
                  :href="'#' + '/new-reimbursement' + '/' + payment.uuid"
                ></a>
                <a
                  v-else
                  v-b-tooltip.hover.left
                  title="Details"
                  class="btn-op icon-info mr-4"
                  :href="'#' + $route.path + '/' + payment.uuid + '?status=' + payment.status"
                ></a> -->

                <b-button
                  variant="primary"
                  size="sm"
                  class="btn-pay-popover"
                  @click="showModalPay('', payment)"
                  ><font-awesome-icon icon="donate"></font-awesome-icon> {{$t('pay')}}</b-button
                >
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="9" class="text-center">There's no data</td>
            </tr>
          </tbody>

          <!-- <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Name</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody v-if="dataApproved.length > 0">
              <template v-for="(payment, index) in dataApproved">
                <tr :key="index">
                    <td>{{getDateTime(payment.createdAt) }}</td>
                    <td>{{payment.requestedBy.name }}</td>
                    <td>{{payment.amount}}</td>
                    <td>
                      <div class="col-md-6" v-if="dataApproved !== null">
                      <a @click="toggle" class="mt-10" style="float: right">
                      <i :class="active ? 'fa fa-minus' : 'fa fa-plus'"></i> {{active ? 'Hide' : 'Show'}}
                      </a>
                    </div>
                    </td>
                </tr>
                <tr :key="index">
                  <td colspan="4">
                  <slide-up-down class="AccordionWrapper" :active="active" :use-hidden="useHidden" :class="timing" :duration="duration">
                    <template v-for="(payment, index) in dataApproved">
                      <div :key="index" class="Options">
                        <p class="properties" style="display: inline-block;">Date : {{getDateTime(payment.createdAt) }}</p>
                      </div>
                    </template>
                  </slide-up-down>
                  </td>
                </tr>
              </template>
              <tr>
                <td></td>
                
              </tr>
            </tbody>
          </table> -->
        </template>
      </table>

      <b-modal id="bv-modal-detail" centered size="xl" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">{{$t('detailApproved')}}</h5>
        </template>
        <table class="table-striped">
          <thead>
            <tr class="py-5">
              <th width="140">{{$t('date')}}</th>
              <th width="140" class="text-center">{{$t('categories')}}</th>
              <th width="240" class="text-center">{{$t('description')}}</th>
              <th width="180" class="text-right">{{$t('amount')}}</th>
              <th width="180" class="text-center">{{$t('approveDate')}}</th>
              <th width="180">{{$t('employee')}}</th>
            </tr>
          </thead>
          <tbody v-for="(detail, i) in dataApproved" :key="i">
            <tr class="mt-3">
              <td width="140">
                {{ detail.createdAt !== null ? getDateTime(detail.createdAt) : '-' }}
              </td>
              <td width="140" class="text-center">
                {{
                  detail.reimburseCategory !== null ? detail.reimburseCategory.categoryName : '-'
                }}
              </td>
              <td width="180">{{ detail.note !== null ? detail.note : '-' }}</td>
              <td width="80" class="text-right">
                {{ dataAccount.account.currency }} {{ formatPrice(detail.amount) }}
              </td>
              <td class="text-center">{{ getDateTime(detail.approvedTime) }}</td>
              <td>{{ detail.requestedBy !== null ? detail.requestedBy.name : '-' }}</td>
            </tr>
          </tbody>
        </table>
        <b-button class="mt-4" size="sm" @click="$bvModal.hide('bv-modal-detail')"
          ><font-awesome-icon icon="times"></font-awesome-icon> {{$t('back')}}</b-button
        >
      </b-modal>

      <b-modal id="bv-modal-payment" centered hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">{{$t('payReimbursement')}}</h5>
        </template>
        <!-- ================================================= -->
        <form v-on:submit.prevent="doChangeStatusPay()">
          <div class="d-block">
            <b-row class="mt-2">
              <b-col md="3">
                <label for="" class="labels">{{$t('paymentDate')}}*</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="8">
                <div class="form-group" v-bind:class="errors.has('date') ? 'has-error' : ''">
                  <b-form-datepicker
                    data-vv-as="date"
                    name="date"
                    v-model="formData.paidTime"
                    v-bind:class="errors.has('date') ? 'is-invalid' : ''"
                    v-validate="'required'"
                    required
                    type="date"
                    class="form-control"
                    :placeholder="$t('date')"
                  />
                  <p v-if="errors.has('date') !== null"></p>
                </div>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col md="3">
                <label for="" class="labels">{{$t('payRefNumber')}}</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="8">
                <b-form-input
                  type="text"
                  v-model="formData.paidRefNumber"
                  :placeholder="$t('payRefNumber')"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col md="3">
                <label for="" class="labels">{{$t('paidFrom')}}*</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="8">
                <v-select
                  id="mySelect"
                  label="text"
                  v-model="formData.paidFrom"
                  :options="list.listAccount"
                  :reduce="(text) => text.value"
                  class="style-chooser"
                  :placeholder="$t('selectAccJournal')"
                >
                  <!-- <template #search="{attributes, events}">
                  <input
                    class="vs__search"
                    :required="!model.customer"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template> -->
                </v-select>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col md="3">
                <label for="" class="labels">{{$t('note')}}</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="8">
                <div class="form-group" v-bind:class="errors.has('date') ? 'has-error' : ''">
                  <b-form-input
                    data-vv-as="date"
                    required
                    name="date"
                    v-bind:class="errors.has('date') ? 'is-invalid' : ''"
                    v-validate="'required'"
                    class="form-control"
                    type="text"
                    v-model="formData.note"
                    :placeholder="$t('note')"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <!-- <label for="" class="mb-1"><strong>Note</strong></label>
                    <b-form-input v-model="formData.note" required placeholder="Enter note"></b-form-input> -->
          </div>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-payment')"
            ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
          >
          <b-button variant="primary" type="submit" class="mt-4 float-right"
            ><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon>
            <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button
          >
        </form>
      </b-modal>
    </b-card>
  </div>
</template>
<script>
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');
import PaginatedTable from '@/components/PaginatedTable';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Typeahead from '@/components/Typeahead';
import SlideUpDown from 'vue-slide-up-down';
Vue.use('slide-up-down', SlideUpDown);
export default {
  name: 'payment-reimbursement',
  components: {
    PaginatedTable,
    DatePicker,
    Typeahead,
  },
  data() {
    return {
      active: false,
      useHidden: true,
      duration: 500,
      showOptions: null,
      timing: '',
      isLoading: false,
      dataKey: 'reimbursement',
      dataAccount: this.$store.getters['account/accountData'],
      apiUrl: {
        profile: window.AppConfig.apiUrl + 'profile',
        reimburseAmountStats: window.AppConfig.apiUrl + 'reimburse-amount-stats',
        reimbursementType: window.AppConfig.apiUrl + 'reimbursement-type',
        reimbursement: window.AppConfig.apiUrl + 'reimbursement',
        exportPayment: window.AppConfig.apiUrl + 'export-payment-reimbursement',
      },
      reimbursementList: [
        {
          value: null,
          text: 'Type',
        },
      ],
      statusList: [
        {
          value: null,
          text: 'Status',
        },
        {
          value: 'Approved',
          text: 'Approved',
        },
        {
          value: 'Paid',
          text: 'Paid',
        },
      ],
      tableFilter: {
        reimbursementType: null,
        search_employee: this.$route.query.search_employee,
        no_request: this.$route.query.no_request,
        status: this.$route.query.status,
        statusreimbursement: null,
        requested_by: this.$route.query.requested_by,
        approved_by: this.$route.query.approved_by,
        rejected_by: this.$route.query.rejected_by,
        reimbursement_type_uuid: this.$route.query.reimbursement_type_uuid,
        date: null,
        start_date: this.$route.query.start_date,
        end_date: this.$route.query.end_date,
        userRequestedBy: {
          value: null,
        },
        userApprovedBy: {
          value: null,
        },
        userRejectedBy: {
          value: null,
        },
      },
      reimburseAmountStats: {
        field: [],
      },
      formData: {
        note: '',
        requested_by: '',
        requestedByUuid: '',
        startDate: '',
        endDate: '',
        paidTime: '',
        paidFrom: '',
        paidRefNumber: '',
      },
      list: {
        listAccount: [],
      },
      dataApproved: [],
      approvedReimburse: {
        uuid: null,
      },
      uuid: '',
      reimburs: '',
    };
  },
  mounted() {
    // this.getReimbursementType()
    // this.getPaymentReimbursement()
    this.getAccountList();
    this.getReimburseAmmontStats();
    // this.getReimbursementStatusApproved();
  },

  watch: {
    'this.uuid'(value) {
      this.toggle(value);
    },
  },
  methods: {
    // getReimbursementStatusApproved(uuid) {
    //   this.$http.get(this.apiUrl.reimbursement + '/' + uuid).then((resp) => {
    //     this.dataApproved = resp.data._embedded.reimbursement;
    //     console.log('uuid', resp);
    //   });
    // },

    getReimburseAmmontStats() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.reimburseAmountStats + '?status=Approved')
        .then((response) => {
          this.approvedReimburse = response.data.payment;
          setTimeout(() => {
            this.isLoading = false;
          }, 2000);
        })
        .catch(() => {
          setTimeout(() => {
            this.getReimburseAmmontStats();
          }, 2000);
        });
    },

    toggleShowOptions() {
      this.showOptions = !this.showOptions;
    },

    toggle() {
      this.active = !this.active;
    },

    doFilter() {
      // this.$refs.dataTable.doFilter(this.tableFilter)
    },
    clearFilter() {
      this.tableFilter.reimbursementType = null;
      this.tableFilter.statusreimbursement = null;
      this.tableFilter.search_employee = null;
      this.tableFilter.search_approved_by = null;
      this.tableFilter.search_rejected_by = null;
      this.tableFilter.date = null;
      this.getPaymentReimbursement();
      // this.$refs.selectableTable.doFilter(this.tableFilter)
    },
    getReimbursementType() {
      this.$http.get(this.apiUrl.reimbursementType + '?limit=100').then((resp) => {
        resp.data._embedded.reimbursementType.forEach((data) => {
          this.reimbursementList.push({
            value: data.uuid,
            text: data.name,
          });
        });
      });
    },
    getAccountList() {
      this.$http
        .get(window.AppConfig.apiUrl + 'journal-account' + '?journalAccountType=D')
        .then((response) => {
          response?.data?._embedded?.journal_account?.forEach((data) => {
            this.list.listAccount.push({
              value: data.uuid,
              text: data.journalAccountCode + ' - ' + data.journalAccountName,
            });
          });
        });
    },
    getPaymentReimbursement() {
      this.isLoading = true;
      let url = this.apiUrl.reimburseAmountStats + '?status=Approved';
      if (
        this.tableFilter.userRequestedBy.value !== undefined &&
        this.tableFilter.userRequestedBy.value !== null
      ) {
        url += '&requested_by=' + this.tableFilter.userRequestedBy.value;
      }
      if (
        this.tableFilter.reimbursementType !== undefined &&
        this.tableFilter.reimbursementType !== null
      ) {
        url += '&reimbursement_type_uuid=' + this.tableFilter.reimbursementType;
      }
      if (
        this.tableFilter.search_employee !== undefined &&
        this.tableFilter.search_employee !== null
      ) {
        url += '&search_employee=' + this.tableFilter.search_employee;
      }
      // if (this.tableFilter.statusreimbursement !== undefined && this.tableFilter.statusreimbursement !== null) {
      //     url += '&status=Approved' + this.tableFilter.statusreimbursement
      // }
      if (
        this.tableFilter.no_request !== undefined &&
        this.tableFilter.no_request !== null &&
        this.tableFilter.no_request !== ''
      ) {
        url += '&no_request=' + this.tableFilter.no_request;
      }
      if (this.tableFilter.date !== null) {
        url +=
          '&start_date=' +
          this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') +
          '&end_date=' +
          this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD');
        this.setFormData();
      }
      this.$http
        .get(url)
        .then((resp) => {
          this.reimburseAmountStats = [];
          // resp.data._embedded.reimbursement.forEach(data => {
          //     // this.reimburseAmountStats.push(data)
          //     temp.push(data.reimburseType !== null ? data.requestedBy.name : '-')
          // })
          // console.log(temp)
          if (resp.data.payment) {
            resp.data.payment.forEach((data, index) => {
              this.reimburseAmountStats.push(data);
            });
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },
    setFormData() {
      this.formData.startDate = this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD');
      this.formData.endDate = this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD');
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    // doFilter () {
    //     this.tableFilter.reimbursement_type_uuid = this.tableFilter.reimbursementType
    //     this.tableFilter.status = this.tableFilter.statusreimbursement
    //     this.tableFilter.approved_by = this.tableFilter.userApprovedBy.value
    //     this.tableFilter.requested_by = this.tableFilter.userRequestedBy.value
    //     this.tableFilter.rejected_by = this.tableFilter.userRejectedBy.value
    //     this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
    //     this.tableFilter.end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
    //     this.$refs.dataTable.doFilter(this.tableFilter)
    // },
    doExportToExcel() {
      let url =
        this.apiUrl.exportPayment +
        '?token=' +
        this.$store.getters['account/tokens'].access_token +
        '&status=Approved';
      //   if (
      //     this.tableFilter.userRequestedBy.value !== undefined &&
      //     this.tableFilter.userRequestedBy.value !== null
      //   ) {
      //     url += '&requested_by=' + this.tableFilter.userRequestedBy.value;
      //   }
      //   if (
      //     this.tableFilter.reimbursementType !== undefined &&
      //     this.tableFilter.reimbursementType !== null
      //   ) {
      //     url += '&reimbursement_type_uuid=' + this.tableFilter.reimbursementType;
      //   }
      //   if (
      //     this.tableFilter.search_employee !== undefined &&
      //     this.tableFilter.search_employee !== null
      //   ) {
      //     url += '&search_employee=' + this.tableFilter.search_employee;
      //   }
      //   if (
      //     this.tableFilter.statusreimbursement !== undefined &&
      //     this.tableFilter.statusreimbursement !== null
      //   ) {
      //     url += '&status=' + this.tableFilter.statusreimbursement;
      //   }
      //   if (
      //     this.tableFilter.no_request !== undefined &&
      //     this.tableFilter.no_request !== null &&
      //     this.tableFilter.no_request !== ''
      //   ) {
      //     url += '&no_request=' + this.tableFilter.no_request;
      //   }
      //   if (this.tableFilter.date !== null) {
      //     url +=
      //       '&start_date=' +
      //       this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') +
      //       '&end_date=' +
      //       this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD');
      //     this.setFormData();
      //   }
      // console.log(url)
      window.open(url);
    },
    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm');
      } else {
        return '-';
      }
    },
    getStatusName(val) {
      switch (val) {
        case 'Approved':
          return this.$root.$t('appr');
          // eslint-disable-next-line no-unreachable
          break;
        case 'Requested':
          return this.$root.$t('req');
          // eslint-disable-next-line no-unreachable
          break;

        case 'Rejected':
          return this.$root.$t('rec');
          // eslint-disable-next-line no-unreachable
          break;
        case 'Paid':
          return this.$root.$t('paid');
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
    reset() {
      this.tableFilter.requestedBy = null;
    },
    showModalDetail(row) {
      this.formData.requestedByUuid = row.uuid;
      this.$http
        .get(this.apiUrl.reimbursement + '?requested_by=' + row.uuid + '&status=Approved')
        .then((resp) => {
          this.dataApproved = resp.data._embedded.reimbursement;
        });
      this.$bvModal.show('bv-modal-detail', { centered: true });
    },

    showModalPay(type, row) {
      this.formData.requestedByUuid = row.uuid;
      this.type = type;
      if (this.$route.name === 'Approved Reimbursement') {
        this.urlName = 'paid-reimburse';
      }
      // this.modelUuid = row.uuid
      this.$bvModal.show('bv-modal-payment');
    },
    doChangeStatusPay() {
      this.isLoading = true;
      this.$http
        .post(window.AppConfig.apiUrl + this.urlName, {
          requested_by: this.formData.requestedByUuid,
          note: this.formData.note,
          paidTime: this.formData.paidTime,
          paidRefNumber: this.formData.paidRefNumber,
          paidFrom: this.formData.paidFrom,
        })
        .then(() => {
          this.isLoading = false;
          // this.formData.requestedBy = null
          // this.formData.note = null
          this.$bvModal.hide('bv-modal-payment');
          this.$store.dispatch('notification/success', this.$route.name + ' has been paid');
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },
    getStatusColor(val) {
      switch (val) {
        case 'Requested':
          return 'info';
          // eslint-disable-next-line no-unreachable
          break;
        case 'New':
          return 'info';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Approved':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Completed':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Rejected':
          return 'danger';
          // eslint-disable-next-line no-unreachable
          break;
        case 'Paid':
          return 'primary';
          // eslint-disable-next-line no-unreachable
          break;
        case false:
          return 'secondary';
          // eslint-disable-next-line no-unreachable
          break;
        case true:
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
        case '0':
          return 'danger';
          // eslint-disable-next-line no-unreachable
          break;
        case '1':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
  },
};
</script>

<style scoped>
.Options {
  display: flex;
  justify-content: space-between;
  align-content: center;
}
</style>
